<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    v-if="profile != null"
>
    <v-card>
        <v-card-title>{{profile.internal_stable_label}}</v-card-title>

        <v-card-text
            v-if="process_id == null"
        >
            
            <v-select
                label="Industry"
                :items="industry_choices"
                v-model="industry"
            />

            <div
                v-if="!is_owned_by_current_user"
            >
                <b>WARNING:</b> This demo account is not owned by you.  Type <code>confirm</code> if you are sure you want to reset another user's demo account.

                <v-text-field
                    label="Confirm"
                    v-model="confirm_text"
                    hint="type 'confirm'"
                />
            </div>

        </v-card-text>

        <v-card-text
            v-if="demo_builder_progress != null"
        >
            <v-checkbox
                v-for="(item, index) in demo_builder_progress.steps"
                :key="index"
                :label="item.text"
                :value="item.value"
                style="margin-bottom: -40px"
                disabled
            />

            <div
                style="height: 25px"
            >
            </div>
        </v-card-text>

        <v-card-actions
            v-if="process_id == null"
        >
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Reset Demo
            </v-btn>

        </v-card-actions>

        <v-card-actions
            v-if="process_id != null"
        >
           <v-spacer></v-spacer>

            <v-progress-circular
                :size="30"
                :width="3"
                color="primary"
                indeterminate
                style="margin-bottom: 7px"
                >
            </v-progress-circular>
           
        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            profile: null,
            industry: null,
            confirm_text: null,

            process_id: null,
            demo_builder_progress: null,
        }
    },

    methods: {

        showDialog(profile)
        {
            this.process_id = null;
            this.demo_builder_progress = null;
            this.profile = profile;
            this.industry = null;
            this.confirm_text = null;

            this.dialog = true;
        },

        onOk()
        {
            if ( !this.is_valid ) return;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'RESET: /api/v1/admin/demo/reset',
            
                'params' : {
                        'organization_id': this.profile.organization_id,
                        'industry': this.industry,
                    },
            
                'on_success': (data) => {
                        this.process_id = data.process_id;
                        this.checkProgress();
                    },
            
                'on_error': 'Unable to reset demo data',
            });
        },

        checkProgress()
        {
            if ( this.process_id == null ) 
                return;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/process/:process_id',
            
                'params' : {
                        'process_id': this.process_id,
                    },
            
                'on_success': (data) => {
                        this.demo_builder_progress = data.status;

                        if ( this.demo_builder_progress.complete )
                        {
                            this.$emit('reset')
                            this.dialog = false;
                            this.$rc.snackbar('Demo setup compelte',1500);
                            return;
                        }

                        window.setTimeout(
                            () => { this.checkProgress(); },
                            1000
                        );
                    },
            
                'on_error': () => {},
            });
        },

        onCancel()
        {
            this.dialog = false;
        },
    },

    computed: {
        industry_choices() {
            return [
                {'text': 'Wine', 'value': 'wine'},
            ];
        },

        is_valid()
        {
            if ( this.industry == null ) return false;
            if ( !this.is_owned_by_current_user && (''+this.confirm_text).toLowerCase().trim() != 'confirm' ) return false;

            return true;
        },

        is_owned_by_current_user()
        {
            if ( this.profile == null ) return false;
            
            return this.profile.redchirp_owner_employee_id == this.$rc.$state.getEmployeeId();
        },
    },
}
</script>

<style lang="scss" scoped>
</style>